import React, { useState, useEffect, useContext } from 'react';

import WishlistButton from './WishlistButton';
import WishlistDropdown from './WishlistDropdown';
import { getFontStylesAsync, getWishlistStyleAsync } from '../../../utils/StoreConfigManager';
import { isMobileDevice } from '../../../utils/DeviceDetector';
import { AddToWishlistContext } from './AddToWishlistContext';
import { TopWishlistIconClicked, WishlistIconClicked } from '../../../utils/Analytics';
import { AppContext } from '../../../AppContext';

const isMobile = isMobileDevice();
const cardStyle = {
    marginBottom: 'auto'
}
const AddToWishlist = ({ sceneSelectorActive, wishListActive, cartActive, showCartActive, showSceneSelector, showWishListActive, currentLanguage }) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [menuTitleFontStyle, setMenuTitleFontStyle] = useState();
    const [menuTextFontStyle, setMenuTextFontStyle] = useState();
    const [wishlistFontStyle, setWishlistFontStyle] = useState();

    const { wishList } = useContext(AddToWishlistContext);
    const { currentSceneName } = useContext(AppContext);

    useEffect(() => {
        (async () => {
            const fontStyles = await getFontStylesAsync();
            const wishlistTextStyles = await getWishlistStyleAsync();
            setMenuTitleFontStyle({
                fontFamily: fontStyles.popUpTitle.name,
                fontSize: fontStyles.popUpTitle.size
            });
            setMenuTextFontStyle({
                fontFamily: fontStyles.popUpText.name,
                fontSize: fontStyles.popUpText.size
            })

            setWishlistFontStyle({
                fontSize: wishlistTextStyles.size,
                fontFamily: wishlistTextStyles.name,
                color: wishlistTextStyles.color,
                text: wishlistTextStyles.text
            })
        })()
    }, [])

    useEffect(() => { 
        if(wishList.length == 0){
            setShowDropdown(false)
        }

    }, [wishList,showDropdown]);

    const closeWishlist = (e) => {
        console.log(e.target);
        if (e.target.tagName === 'CANVAS') {
            setShowDropdown(false);
            showWishListActive(false);

            if (isMobile) {
                document.removeEventListener('touchend', closeWishlist);
            } else {
                document.removeEventListener('click', closeWishlist)
            }
        }
    }

    const handleWishlistButtonClick = () => {
        const showingDropdown = !showDropdown
        setShowDropdown(showingDropdown);
        if (sceneSelectorActive) {
            showSceneSelector(false);
        }
        if (cartActive) {
            showCartActive(false);
        }
        showWishListActive(!wishListActive);

        if (showingDropdown) {
            TopWishlistIconClicked(currentSceneName)
            if (isMobile) {
                document.addEventListener('touchend', closeWishlist);
            } else {
                document.addEventListener('click', closeWishlist)
            }
        } else {
            if (isMobile) {
                document.removeEventListener('touchend', closeWishlist);
            } else {
                document.removeEventListener('click', closeWishlist)
            }
        }
    }

    return (
        <div id='add-to-wishlist-container' className="align-right" style={cardStyle}>
                    <WishlistButton
                        onClick={handleWishlistButtonClick}
                        itemCount={wishList.length}
                    />
            <WishlistDropdown
                wishlistTitle='wishlistTitle'
                showDropdown={wishListActive}
                menuTextFontStyle={menuTextFontStyle}
                menuTitleFontStyle={menuTitleFontStyle}
                wishlistFontStyle={wishlistFontStyle}
                wishList={wishList}
                closeMenu={handleWishlistButtonClick}
                currentLanguage={currentLanguage}
                currentSceneName={currentSceneName}
            />
        </div>
    )
}

export default AddToWishlist;
